import React from "react";
import moment from "moment";
import style from "./OrderCreatedCard.module.scss";
import { useTranslation } from "react-i18next";

const EMPTY_VALUE = "-";

const OrderCreatedCard = ({ order }) => {
  const { t } = useTranslation();

  if (!order) return null;

  const createdDate = order.createdAt ? moment(order.createdAt).format("DD.MM.YYYY") : EMPTY_VALUE;
  const titleKey =
    order.assignmentMethod === "Auction"
      ? "orderInfoClient.orderCreatedCard.auctionTitle"
      : order.assignmentMethod === "Tender"
        ? "orderInfoClient.orderCreatedCard.tenderTitle"
        : "orderInfoClient.orderCreatedCard.title";

  return (
    <div className={style.card}>
      <div className={style.header}>
        <span className={style.title}>{t(titleKey)}</span>
      </div>
      <div className={style.row}>
        <span className={style.item}>
          <span className={style.item_label}>{t("orderInfoClient.orderCreatedCard.createdBy")} </span>
          <span className={style.item_value}>{order.author || EMPTY_VALUE}</span>
        </span>
        <span className={style.item}>
          <span className={style.item_label}>{t("orderInfoClient.orderCreatedCard.createdAt")} </span>
          <span className={style.item_value}>{createdDate}</span>
        </span>
      </div>
    </div>
  );
};

export default OrderCreatedCard;
